import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'

// guest reviewer only
export class AnnotationDetailAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(token, orderId, attachmentId, versionId, next, complete, error) {
    const httpConfig = {
      url: `/g/guest/order/${orderId}/attachment/${attachmentId}/version/${versionId}`,
      method: 'get',
      headers: {
        accept: 'application/json',
        'Content-Type': `application/json`,
        Authorization: `Bearer ${token}`,
      },
    }

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig, false)
    })

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error,
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
